import React from 'react';
import { useAuth } from '@domain/auth/auth.hook';
import { useFormData } from '@domain/hooks/use.form.data';
import { RequestDialog } from '@components/dialog/request.dialog';
import { ToggleDialogProps } from '@screens/players/player.actions/toggles/toggle.dialog.props';

const CleanCacheDialog = ({ player, ...rest }: ToggleDialogProps) => {
  const { authorizedServices } = useAuth();
  const { pid } = player;

  const formData = useFormData({}, function requestCacheClean(data, cancelToken) {
    return authorizedServices.patch(`/admin/toggles/clean-cache/${pid}`, { params: data, cancelToken });
  });

  return (
    <RequestDialog formData={formData} icon='cleaning_services' title='Clean cache' successMsg='Player cache cleaned successfully!' {...rest}>
      Confirm cache cleanup for this player?
    </RequestDialog>
  );
};

export default CleanCacheDialog;
